import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

const VideoProgressBar = ({ video_time = 0, duration = 0, height = 4 }) => {
  const time = parseFloat(video_time || 0);
  const total = parseFloat(duration || 0);

  if (!total || isNaN(time) || isNaN(total) || time <= 0) return null;

  const progress = Math.min((time / total) * 100, 100);
  const remaining = Math.max(total - time, 0);

  const formatTime = (ms) => {
    const seconds = Math.floor(ms / 1000);
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return [
      hrs.toString().padStart(2, '0'),
      mins.toString().padStart(2, '0'),
      secs.toString().padStart(2, '0'),
    ].join(':');
  };

  const tooltipLabel = `${formatTime(remaining)} remaining`;

  return (
    <Tooltip title={tooltipLabel} arrow>
      <Box sx={{ width: '100%', cursor: 'help' }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height,
            borderRadius: 2,
            backgroundColor: '#e0e0e0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#4a0072',
            },
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default VideoProgressBar;
